import React from 'react';
import './Modal.css';

function AddNodeModal({ nodes, onAddNode, onCancel }) {
    const [selectedNodeId, setSelectedNodeId] = React.useState("");
    const [newNodeName, setNewNodeName] = React.useState("");

    return (
        <div>
            <h4>Create Node</h4>
            <div>
                <label>
                    Node Name:
                    <input type="text" value={newNodeName} onChange={(e) => setNewNodeName(e.target.value)} />
                </label>
            </div>

            <div>
                <span>Connect <span className='tag-general'>{newNodeName || "new node"}</span> to </span>

                <label>
                    <select value={selectedNodeId} onChange={(e) => setSelectedNodeId(e.target.value)}>
                        <option value="">Select...</option>
                        {nodes.map((node) => (
                            <option value={node.nid}>{node.name}</option>
                        ))}
                    </select>
                </label>
            </div>

            <div className="modal-actions">
                <button onClick={onCancel}>Cancel</button>
                <button
                    onClick={() => {
                        onAddNode({ nid: selectedNodeId, name: newNodeName });
                        setSelectedNodeId(""); // reset selected node ID after merging
                        setNewNodeName(""); // reset node name after merging
                    }}
                    disabled={!selectedNodeId || !newNodeName.trim()}
                >
                    Submit
                </button>
            </div>
        </div>
    );
}

export default AddNodeModal;
